import { useCallback, useState } from "react";
import { isEqual } from "@common/helpers/comparison";
import { omitBy } from "@common/helpers/objects";
import { ClientsFilters } from "@common/schemas/client.schema";

const DEFAULT_FILTERS = {};

export function useClientsFilters(
    onFiltersChange: () => void,
    initialFilters?: ClientsFilters,
) {
    const [filters, setFilters] = useState<ClientsFilters>(
        initialFilters ?? DEFAULT_FILTERS,
    );

    const handleFiltersChange = useCallback(
        (value: ClientsFilters) => {
            const newFilters = omitBy(
                { ...filters, ...value },
                (v) => v === null || v === undefined,
            );

            if (!isEqual(newFilters, filters)) {
                setFilters(newFilters);
                onFiltersChange();
            }
        },
        [filters, onFiltersChange],
    );

    const resetFilters = useCallback(() => {
        setFilters({});
        onFiltersChange();
    }, [onFiltersChange]);

    const hasActiveFilters = !isEqual(filters, {});

    return {
        filters,
        handleFiltersChange,
        resetFilters,
        hasActiveFilters,
    };
}
